import { ReactNode } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { StepComponent } from "./step.component";

type Props = {
    steps: Array<{
        tk: string;
        optional: boolean;
        isComplete: boolean;
        isSkipped: boolean;
    }>;
    stepIndex: number;
    activeStepIndex: number;
    onSkipStep: () => void;
    onEditStep: () => void;
    children: ReactNode;
};

export const Step = ({
    steps,
    stepIndex,
    activeStepIndex,
    onSkipStep,
    onEditStep,
    children
}: Props) => {
    const { t } = useGranite();

    return (
        <StepComponent
            step={stepIndex + 1}
            title={t(steps[stepIndex].tk)}
            complete={steps[stepIndex].isComplete}
            skipped={
                steps[stepIndex].isSkipped ||
                (activeStepIndex > stepIndex && !steps[stepIndex].isComplete)
            }
            active={activeStepIndex === stepIndex}
            skippable={steps[stepIndex].optional}
            skip={onSkipStep}
            edit={onEditStep}
        >
            {children}
        </StepComponent>
    );
};
